import React, { forwardRef } from 'react';
import { InputArea, InputAttribute, InputErrorMessage, InputLabel } from './styles';
import { InputProps } from '@src/components/reusable/input/BaseInput/types';

const BaseInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { name, label, error, helperText, renderInput } = props;

  return (
    <InputArea>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      {renderInput ? renderInput(props) : <InputAttribute {...props} ref={ref} />}
      {helperText ? <InputErrorMessage error={error}>{helperText}</InputErrorMessage> : null}
    </InputArea>
  );
});

BaseInput.displayName = 'BaseInput';

export default BaseInput;
